// extracted by mini-css-extract-plugin
export default {"follow-up-input__actions-cluster":"S0wJuI","follow-up-input__attachment-field":"ZbKQYz"};